import { DataBean } from "../DataBean";

export class UnitaryValueAll extends DataBean {



    public async setUnitaryValueToAllProductionRoute(value:any,replaceAll:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_setUnitaryValueToAllProductionRoute_Number_Boolean", [value,replaceAll]);
    }
    
}